import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import noScrollbar from 'Theme/GlobalStyles/noScrollbar'

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${themeGet('space.11')}px;
  overflow-x: auto;

  @media screen and (min-width: ${themeGet('breakpoints.4')}) {
    justify-content: center;
  }

  > div > svg {
    flex-shrink: 0;
    width: 190px;
    height: 160px;
  }

  ${noScrollbar}
`

export const IFrameHolder = styled.div`
  display: flex;
  align-items: center;
  width: 118px;
  height: 160px;
  flex-shrink: 0;

  iframe {
    border: none;
    height: 100%;
    width: 100%;
  }
`
